import newUserView from './AppNewUserView.html'
import newUserCtrl from './AppNewUserCtrl';
import confirmDeleteView from '../app.modal/confirmDeleteModal.html';

export default function ($rootScope, $scope, $http, $q, $timeout, $stateParams, $state, $uibModal, $firebaseObject, CONFIG, FirebaseFactory, users, isAdmin, $location) {
    'ngInject';

    $scope.isProgress = false;
    $scope.users = users;
    let keys = [];
    /*console.log($rootScope.firebaseUser);

    let user = {
        displayName: 'Valerio Pisapia',
        uid: $rootScope.firebaseUser.uid,
        isAdmin: true,
        permissions: ['region_id_1', 'region_id_2']
    };

    FirebaseFactory.saveUser(user);*/

    /***
     * Get all Users
     */
    let getUsers = () => {
        $scope.isProgress = true;
        $scope.users = [];
        let ref = FirebaseFactory.getUsers();
        let obj = $firebaseObject(ref);

        obj.$loaded().then( () => {
            console.log(obj);
            $scope.isProgress = false;
            let __users = obj;
            keys = Object.keys(__users);

            _.map(keys, (key) => {
                console.log(key, key.length);
                if (key.length > 19) {
                    __users[key].uid = key;
                    $scope.users.push(__users[key]);
                }
            });

            console.log($scope.users);
        });
    };


    /***
     * Delete a user
     * @param index
     */
    let deleteUser = (index) => {
        FirebaseFactory.removeUser(index);
        getUsers();
    };


    /***
     * Check if logged user is admin
     */
    let checkisAdmin = () => {
        if (!isAdmin || !!!isAdmin) {
            $state.go('home');
        } else {
            getUsers();
        }
    };

    /***
     * Add new User
     */
    $scope.addNewUser = () => {
        let modalInstance = $uibModal.open({
            template: newUserView,
            controller: newUserCtrl,
            controllerAs: 'vm',
            resolve: {}
        });

        modalInstance.result.then(() => {
            getUsers();
        });
    };

    /***
     * Get Region name
     * @param id
     */
    $scope.getRegion = (id) => {
       let region =  !!$rootScope.allRegions ? $rootScope.allRegions.filter( (region) => {return region.sys.id === id }) : [];
       return region.length > 0 ? region[0].fields.title : '';
    };


    /***
     *
     * Delete selected user
     * @param entryId
     */
    $scope.remove = (userId) => {
        let modalInstance = $uibModal.open({
            template: confirmDeleteView
        });

        modalInstance.result.then(() => {
            deleteUser(userId);
        });

        $scope.$root.modal = modalInstance;
    };

    // get actice user ID
    const curLoaction = $location.$$url;
    $scope.activeId = curLoaction.replace('/user/', '');

    checkisAdmin();
}



// WEBPACK FOOTER //
// ./src/app/views/app.sidenav/AppSideNavUserCtrl.js